// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 895) return "895/895.836adb7ef37d0fbe628f.min.css";
	if (chunkId === 622) return "finances/finances.5f7b3127e4636212a3d9.min.css";
	// return url for filenames based on template
	return undefined;
};